"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var log_1 = require("../utils/log");
var utils_1 = require("../utils/utils");
var __1 = require("..");
var AuctionHandler_1 = require("./AuctionHandler");
var OpenRtb_1 = require("./OpenRtb");
var Bid_1 = require("./Bid");
var ConsentHandler_1 = require("./consent/ConsentHandler");
var moduleTypes_1 = require("../modules/consent/moduleTypes");
var activities_1 = require("../modules/consent/activities");
var UserSync_1 = require("./UserSync");
var Storage_1 = __importDefault(require("./Storage"));
var Page_1 = require("./Page");
var Auction = /** @class */ (function () {
    function Auction() {
        this._id = '';
        this.endpoint = 'https://pulsar.bigcrunch.com/s2s/bids';
        this.openRtb = {};
        this.slots = [];
        this.done = false;
        this._id = (0, utils_1.generateUUID)();
    }
    Object.defineProperty(Auction.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Auction.prototype.init = function () {
        this.openRtb = OpenRtb_1.ortbObject.initObj();
    };
    /**
     * Function to add slots to payload
     * @param slots
     * @returns void
     */
    Auction.prototype.addSlotsToAuction = function (slots) {
        var _a;
        (_a = this.slots).push.apply(_a, slots);
    };
    /**
     * Function to prepare payload
     * @returns object
     */
    Auction.prototype.preparePayload = function () {
        var _a, _b;
        var payload = {
            property_id: __1.globalSettings.property_id,
            auction_id: this._id,
            page_id: Page_1.globalPage.id,
            ortb: this.openRtb,
            slots: {},
            bidders: {},
            cookies: {},
            consent: (_a = {},
                _a[activities_1.ACTIVITY_ACCESS_DEVICE] = ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_ACCESS_DEVICE, { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'gvlid': {} }),
                _a[activities_1.ACTIVITY_TRANSMIT_EIDS] = ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_TRANSMIT_EIDS, { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'gvlid': {} }),
                _a[activities_1.ACTIVITY_TRANSMIT_PRECISE_GEO] = ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_TRANSMIT_PRECISE_GEO, { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'gvlid': {} }),
                _a),
        };
        // loop through slots
        this.slots.forEach(function (slot) {
            if (slot.sizes.length) {
                var payloadSlot = {
                    id: slot.id,
                    name: slot.name,
                    divid: slot.div_id,
                    sizes: slot.sizes,
                    floor: slot.floor || 0.10
                };
                // add slot to payload
                payload.slots[slot.name] = payloadSlot;
            }
        });
        // copy bidders from global settings
        var bidders = (0, utils_1.deepCopy)(__1.globalSettings.bidders);
        // loop through bidders
        for (var bidder_name in bidders) {
            // get bidder
            var bidder = bidders[bidder_name];
            // check if test is enabled
            if (__1.globalSettings.test.enabled && __1.globalSettings.test.bidders.length) {
                // check if bidder is in test bidders
                if (!__1.globalSettings.test.bidders.includes(bidder_name)) {
                    // delete bidder
                    delete bidders[bidder_name];
                    continue;
                }
                // check if bidder is enabled
            }
            else if (!bidder.config.enabled) {
                // delete bidder
                delete bidders[bidder_name];
                continue;
            }
            // check if user id exists in storage
            var buyeruid = UserSync_1.globalUserSync.getUserIdFromStorage(bidder_name);
            if (buyeruid) {
                bidder.config.buyeruid = buyeruid;
                // add buyeruid to payload cookies
                payload.cookies["".concat(UserSync_1.USYNC_STORAGE_PREFIX).concat(bidder_name)] = buyeruid;
            }
            var _loop_1 = function (slot_name) {
                // check if slot exists in payload
                if (payload.slots[slot_name]) {
                    for (var tag_id in bidder.slots[slot_name]) {
                        // get all sizes that are in both bidder and payload slots arrays
                        var sizes = bidder.slots[slot_name][tag_id].filter(function (size) { return payload.slots[slot_name].sizes.includes(size); });
                        if (sizes.length) {
                            // add slot to bidder
                            bidder.slots[slot_name][tag_id] = sizes;
                        }
                        else {
                            // delete slot from bidder
                            delete bidder.slots[slot_name][tag_id];
                            continue;
                        }
                    }
                    if (!Object.keys(bidder.slots[slot_name]).length) {
                        // delete slot from bidder
                        delete bidder.slots[slot_name];
                        return "continue";
                    }
                }
                else {
                    // delete slot from bidder
                    delete bidder.slots[slot_name];
                    return "continue";
                }
            };
            // loop through bidder slots
            for (var slot_name in bidder.slots) {
                _loop_1(slot_name);
            }
            if (!Object.keys(bidder.slots).length) {
                // delete bidder
                delete bidders[bidder_name];
            }
            else {
                bidders[bidder_name].consent = (_b = {},
                    _b[activities_1.ACTIVITY_ACCESS_DEVICE] = ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_ACCESS_DEVICE, { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'componentName': bidder_name }),
                    _b[activities_1.ACTIVITY_TRANSMIT_EIDS] = ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_TRANSMIT_EIDS, { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'componentName': bidder_name }),
                    _b[activities_1.ACTIVITY_TRANSMIT_PRECISE_GEO] = ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_TRANSMIT_PRECISE_GEO, { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'componentName': bidder_name }),
                    _b);
            }
        }
        if (Object.keys(bidders).length) {
            payload.bidders = bidders;
        }
        return payload;
    };
    /**
     * Function to send auction request to server URL
     */
    Auction.prototype.sendAuctionRequest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payload, endpoint;
            var _this = this;
            return __generator(this, function (_a) {
                // if slots lnegth is 0 then return
                if (!this.slots.length) {
                    (0, log_1.logInfo)("No slots to send auction request.");
                    return [2 /*return*/, false];
                }
                payload = this.preparePayload();
                if ((!payload.bidders ||
                    !Object.keys(payload.bidders).length) ||
                    (!payload.slots ||
                        !Object.keys(payload.slots).length)) {
                    (0, log_1.logInfo)("No bidders or slots to send auction request.");
                    return [2 /*return*/, false];
                }
                (0, log_1.logInfo)("Sending Auction Request.");
                endpoint = this.endpoint + (__1.globalSettings.test.enabled && __1.globalSettings.test.ads ? '/test' : '');
                // Send post request with JSON payload using fetch API with timeout
                (0, utils_1.fetchWithTimeout)(endpoint, 2000, {
                    method: 'POST',
                    body: JSON.stringify(payload),
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    credentials: 'include',
                })
                    .then(function (response) {
                    return response.json();
                }).then(function (json) {
                    _this.parseResponse(json);
                }).catch(function (err) {
                    (0, log_1.logWarn)("Error sending auction request.", err);
                });
                this.done = true;
                AuctionHandler_1.auctionHandler.auctionFinished(this);
                return [2 /*return*/, true];
            });
        });
    };
    Auction.prototype.parseResponse = function (json) {
        if (json.slots && Object.keys(json.slots).length) {
            var _loop_2 = function (slot_name) {
                // get slot
                var slot = this_1.slots.find(function (slot) { return slot.name === slot_name; });
                if (slot) {
                    var bids = (json.slots[slot_name].bids || []).map(function (bid) { return new Bid_1.Bid(bid, slot); });
                    // add bids to slot
                    slot.auctionFinished(bids);
                }
            };
            var this_1 = this;
            for (var slot_name in json.slots) {
                _loop_2(slot_name);
            }
        }
        if (json.cookies &&
            ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_ACCESS_DEVICE, { gvlid: {} })) {
            for (var cookie_name in json.cookies) {
                var bidder_name = cookie_name.replace(UserSync_1.USYNC_STORAGE_PREFIX, '');
                var storageObj = { 'componentType': moduleTypes_1.MODULE_TYPE_BIDDER, 'componentName': bidder_name };
                // check if cookie exists
                if (Storage_1.default.getItemFromStorage(cookie_name, storageObj)) {
                    // check if cookie value is different
                    if (Storage_1.default.getItemFromStorage(cookie_name, storageObj) !== json.cookies[cookie_name]) {
                        // update cookie
                        Storage_1.default.setItemInStorage(cookie_name, json.cookies[cookie_name], storageObj);
                    }
                }
                else {
                    // set cookie
                    Storage_1.default.setItemInStorage(cookie_name, json.cookies[cookie_name], storageObj);
                }
            }
        }
    };
    return Auction;
}());
exports.default = Auction;
